import React from 'react';

import * as classnames from 'classnames';
import PropTypes from 'prop-types';

import { WOODSMOKE } from '../../constant/colors';

import Icon from '@component/icon';

const BASE_CLASS_NAME = 'alert';

export const ALERT_TYPES = {
  ERROR: 'error',
  HIGHLIGHT: 'highlight',
  WARNING: 'warning',
};

/**
 * Shows highlighted text and optionally an icon
 *
 * @param  {string} text The banner text
 * @param  {string} [icon]   Icon that is rendered next to the text
 * @param {('warning'|'error'|'highlight')} [type] - The type of banner that relates to a color
 */
export const Alert = ({
  text,
  icon,
  type = ALERT_TYPES.HIGHLIGHT,
  className,
}) => (
  <div
    className={classnames(BASE_CLASS_NAME, className, {
      [`${BASE_CLASS_NAME}--warning`]: type === ALERT_TYPES.WARNING,
      [`${BASE_CLASS_NAME}--error`]: type === ALERT_TYPES.ERROR,
      [`${BASE_CLASS_NAME}--highlight`]: type === ALERT_TYPES.HIGHLIGHT,
    })}
  >
    {icon && (
      <span className={`${BASE_CLASS_NAME}__icon`}>
        <Icon type={icon} color={WOODSMOKE} />
      </span>
    )}
    <p className={`${BASE_CLASS_NAME}__text`}>{text}</p>
  </div>
);

Alert.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(ALERT_TYPES)),
  icon: PropTypes.string,
  className: PropTypes.string,
};
